import React, { useState, useEffect } from 'react';
import { Typography, Table, Button, message, Row, Col } from 'antd';
import axios from 'axios';
import Image from '../images/banner_carousel.webp';
import Cultos from './Cultos';

const { Title, Text } = Typography;

const MaterialDeLectura = () => {
  const [files, setFiles] = useState([]);
  const [hasError, setHasError] = useState(false);
  const folderId = process.env.REACT_APP_GOOGLE_DRIVE_CULTOS_FOLDER_ID;
  const apiKey = process.env.REACT_APP_GOOGLE_API_KEY;

  useEffect(() => {
    const fetchFiles = async () => {
      try {
        const response = await axios.get(
          `https://www.googleapis.com/drive/v3/files`,
          {
            params: {
              q: `'${folderId}' in parents`,
              key: apiKey,
              fields:
                'files(id, name, size, mimeType, webContentLink,createdTime)',
            },
          }
        );

        const processedFiles = response.data.files
          .map((file) => ({
            key: file.id,
            name: file.name,
            size: file.size
              ? `${(file.size / (1024 * 1024)).toFixed(1)} MB`
              : 'Desconocido',
            link:
              file.webContentLink ||
              `https://drive.google.com/file/d/${file.id}/view`,
            createdTime: new Date(file.createdTime),
          }))
          .sort((a, b) => b.createdTime - a.createdTime);

        setFiles(processedFiles);
      } catch (error) {
        console.error('Error fetching files:', error);
        setHasError(true);
        message.error('Error al cargar los cultos.');
      }
    };

    fetchFiles();
  }, [folderId, apiKey]);

  const columns = [
    {
      title: 'Nombre',
      dataIndex: 'name',
      key: 'name',
      onHeaderCell: () => ({
        style: {
          fontFamily: 'Outfit', // Apply 'Outfit' font to the column title
        },
      }),
      onCell: () => ({
        style: {
          fontFamily: 'Roboto', // Apply 'Roboto' font to the cell text
        },
      }),
    },
    {
      title: 'Peso',
      dataIndex: 'size',
      key: 'size',
      onHeaderCell: () => ({
        style: {
          fontFamily: 'Outfit', // Apply 'Outfit' font to the column title
        },
      }),
      onCell: () => ({
        style: {
          fontFamily: 'Roboto', // Apply 'Roboto' font to the cell text
        },
      }),
    },
    {
      title: 'Descargar',
      dataIndex: 'link',
      key: 'link',
      onHeaderCell: () => ({
        style: {
          fontFamily: 'Outfit', // Apply 'Outfit' font to the column title
        },
      }),
      onCell: () => ({
        style: {
          fontFamily: 'Roboto', // Apply 'Roboto' font to the cell text
        },
      }),
      render: (link) => (
        <Button
          type="link"
          href={link}
          target="_blank"
          rel="noopener noreferrer"
        >
          Descargar
        </Button>
      ),
    },
  ];

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
      }}
    >
      {/* Main Content */}
      <div style={{ flex: 1 }}>
        {/* Banner */}
        <div
          style={{
            width: '100%',
            height: '300px',
            backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url(${Image})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Title
            level={1}
            style={{
              color: 'white',
              fontSize: '48px',
              textShadow: '2px 2px 4px rgba(0, 0, 0, 0.7)',
              fontFamily: 'Outfit',
            }}
          >
            Audios de cultos
          </Title>
        </div>

        {/* Content */}
        <div style={{ padding: '40px' }}>
          <Cultos
            title="Diccionario de audios"
            description="Accedé gratuitamente al diccionario audios de cultos."
            qrUrl="https://docs.google.com/spreadsheets/d/1MNt4DWR9CaVQWlgZebzUYaO-KGUpjwExvt4nmpkY0lc/edit?usp=sharing"
            buttonText="Ver diccionario"
          />
          {files.length > 0 && !hasError ? (
            <Row justify="center">
              <Col xs={24} lg={18}>
                <Table
                  dataSource={files}
                  columns={columns}
                  pagination={{
                    pageSize: 5,
                    position: ['bottomCenter'], // Center the pagination
                  }}
                  bordered
                />
              </Col>
            </Row>
          ) : (
            <Text
              style={{
                fontFamily: 'Roboto',
                fontSize: '18px',
                color: 'rgba(0, 0, 0, 0.65)',
                textAlign: 'center',
                display: 'block',
              }}
            >
              No hay cultos disponibles en este momento...
            </Text>
          )}
        </div>
      </div>
    </div>
  );
};

export default MaterialDeLectura;
